import { api } from "@lib/orpc-client"
import { ApiError } from "@lib/api"
import { useTranslation } from "react-i18next"
import { useState } from "react"

const useReferral = () => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')

    const postReferral = async ({ referral_code }: { referral_code: string }) => {
        try {
            setError('')
            setIsLoading(true)
            await api.walletV2.referral.submit({ referral_code })
            return true
        } catch (err: unknown) {
            if (err instanceof ApiError && err.errorCode) {
                setError(t(`errors.${err.errorCode}.description`))
            } else {
                setError(t('page.createWallet.steps.referralCode.errorText'))
            }
            return false
        } finally {
            setIsLoading(false)
        }
    }

    return {
        postReferral,
        isLoading,
        error
    }
}

export default useReferral